import { defineElement, FC, useBindMethod } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { closeModal } from '@store/modals';
import { useStylesheet } from '@utilities/hooks';
import { isLocalhost } from '@utilities/sw';

import style from './login-screen.scss';

const USER_LOGIN_MODAL_ID = 'login-screen';

export interface LoginScreenInterface extends HTMLElement {
    closeAndRemove: Function;
}

const LoginScreen: FC<LoginScreenInterface> = ({ element }) => {
    let popupWindow: null | WindowProxy = null;
    useStylesheet(style);
    useBindMethod('closeAndRemove', closeAndRemove);

    function getiframeSrc() {
        if (isLocalhost) {
            return 'https://hoefenhaag.u8projects.bpdtest.nl/umbraco/surface/saml/authrequest?host=hoefenhaag.u8projects.bpdtest.nl&id=a0iw0000008QvIVAA0&protocol=https';
        }

        const hostname = window.location.hostname;
        const areaId = window.__ENVIRONMENT_DETAILS__.areaId;

        return `/umbraco/surface/saml/authrequest?host=${hostname}&id=${areaId}&protocol=https`;
    }

    function isMobile() {
        return /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(navigator.appVersion);
    }

    function isSafari() {
        const userAgent = navigator.userAgent.match(
            /(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i,
        );

        if (!userAgent) return false;

        const browser = userAgent[1].toLowerCase();

        return browser === 'safari';
    }

    function type() {
        return popupWindow ? 'popup' : 'modal';
    }

    function openPopup() {
        const width = 900;
        const height = 475;
        const left = window.screen.width / 2 - (width / 2 + 10);
        const top = window.screen.height / 2 - (height / 2 + 50);

        return window.open(
            getiframeSrc(),
            'Login',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
        );
    }

    function closeAndRemove() {
        switch (type()) {
            case 'popup':
                popupWindow?.close();
                element.remove();
                break;
            case 'modal':
                closeModal(USER_LOGIN_MODAL_ID);
                element.remove();
                break;
        }
    }

    if (isSafari()) {
        popupWindow = isMobile() ? window.open(getiframeSrc()) : openPopup();

        return '';
    }

    return (
        <bpd-iframe-modal
            classes="c-login-screen"
            active={true}
            id={USER_LOGIN_MODAL_ID}
            iframe-id="login-iframe" // For QA
            src={getiframeSrc()}
            min-width="100%"
            min-height="41.2rem"></bpd-iframe-modal>
    );
};

defineElement('bpd-login-screen', LoginScreen);
